//loader.js
window.$ = window.jQuery = require('jquery')

